import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "image", "src", "name", "displayName", "secondaryName", "containerClassName", "contentStyle", "className", "colorizeOnName", "contentClassName", "initials", "componentStyles", "maxLength"];
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Avatar as AntdAvatar } from 'antd';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import Ellipsis from '../Ellipsis';
import Content from '../Content';
import PropertyControlledComponent from '../../molecules/PropertyControlledComponent';
import styles from './avatar.module.scss';
var getAvatarSize = function getAvatarSize(size) {
  switch (size) {
    case 'small':
      return styles.avatarSizeSmall;
    case 'medium':
      return styles.avatarSizeMedium;
    case 'large':
      return styles.avatarSizeLarge;
    default:
      return size;
  }
};
var getInitialsFromName = function getInitialsFromName(name) {
  var initials = name ? name.match(/\b\w/g) || [] : [];
  return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
};
var getBackgroundColorClass = function getBackgroundColorClass(name, colorizeOnName) {
  if (!name || !colorizeOnName) {
    return styles.denimBackground;
  }
  var firstLetter = (name || '').charAt(0).toUpperCase();
  if (firstLetter >= 'A' && firstLetter <= 'E') return styles.mediumPurpleBackground;
  if (firstLetter >= 'F' && firstLetter <= 'J') return styles.cornFlowerBlueBackground;
  if (firstLetter >= 'K' && firstLetter <= 'O') return styles.pictonBlueBackground;
  if (firstLetter >= 'P' && firstLetter <= 'T') return styles.skyMagentaBackground;
  if (firstLetter >= 'U' && firstLetter <= 'Z') return styles.supernovaBackground;
  return styles.denimBackground;
};
var Avatar = function Avatar(props) {
  var size = props.size,
    image = props.image,
    src = props.src,
    name = props.name,
    displayName = props.displayName,
    secondaryName = props.secondaryName,
    containerClassName = props.containerClassName,
    contentStyle = props.contentStyle,
    className = props.className,
    colorizeOnName = props.colorizeOnName,
    contentClassName = props.contentClassName,
    initials = props.initials,
    componentStyles = props.componentStyles,
    maxLength = props.maxLength,
    rest = _objectWithoutProperties(props, _excluded);
  var avatarSize = getAvatarSize(size);
  var _ref = _isNumber(avatarSize) ? [avatarSize, ''] : [false, avatarSize],
    _ref2 = _slicedToArray(_ref, 2),
    avatarSizeProp = _ref2[0],
    avatarSizeClass = _ref2[1];
  var avatarInitials = !_isEmpty(initials) ? initials : getInitialsFromName(name);
  var avatarClass = cx(styles.avatarComponent, className, getBackgroundColorClass(name, colorizeOnName), avatarSizeClass);
  var stylingProp = !_isEmpty(componentStyles) ? {
    style: componentStyles
  } : {
    className: avatarClass
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.avatar, " ").concat(containerClassName)
  }, /*#__PURE__*/React.createElement(AntdAvatar, _extends({}, rest, {
    src: image || src,
    size: avatarSizeProp
  }, stylingProp), avatarInitials), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: displayName
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.userName
  }, /*#__PURE__*/React.createElement(Content, {
    style: contentStyle,
    className: contentClassName
  }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: maxLength,
    fallback: name
  }, /*#__PURE__*/React.createElement(Ellipsis, {
    tooltip: true,
    length: maxLength
  }, name))), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: secondaryName
  }, /*#__PURE__*/React.createElement(Content, {
    className: styles.secondaryName
  }, secondaryName)))));
};
Avatar.propTypes = {
  size: PropTypes.string,
  image: PropTypes.string,
  name: PropTypes.string,
  containerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  displayName: PropTypes.bool,
  secondaryName: PropTypes.string,
  style: PropTypes.object,
  contentStyle: PropTypes.object,
  className: PropTypes.string,
  colorizeOnName: PropTypes.bool,
  initials: PropTypes.string,
  componentStyles: PropTypes.object,
  maxLength: PropTypes.number
};
Avatar.defaultProps = {
  size: 'medium',
  image: null,
  containerClassName: EMPTY_STRING,
  name: null,
  displayName: true,
  secondaryName: null,
  style: EMPTY_OBJECT,
  contentStyle: EMPTY_OBJECT,
  className: EMPTY_STRING,
  contentClassName: EMPTY_STRING,
  colorizeOnName: true,
  initials: EMPTY_STRING,
  componentStyles: EMPTY_OBJECT,
  maxLength: 0
};
export default Avatar;